/**
 * Obra view component.
 * @module components/Views/ObraView
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@plone/components';
import { TableRow, TableCell, TableBody, Table } from 'semantic-ui-react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { DownloadLink } from '../DownloadActions/DownloadActions';
import LocalDate from '../LocalDate/LocalDate';

const Fornecedor = ({ item }) => {
  const hasLink = item?.['@id'] ? true : false;
  return hasLink ? (
    <UniversalLink item={item} className={'fornecedor'}>
      {item.title}
    </UniversalLink>
  ) : (
    <span className={'fornecedor'}>{item.title}</span>
  );
};

const ObraView = (props) => {
  const { content } = props;
  const file_href = content.file && content.file.download;
  const file_acompanhamento_href =
    content.file_acompanhamento && content.file_acompanhamento.download;
  return (
    <Container narrow id="page-document" className="view-wrapper obra-view">
      <h1 className="documentFirstHeading">{content.title}</h1>
      <span>{content.status.title}</span>
      <Table className={'details'}>
        <TableBody>
          {content.fornecedor && (
            <TableRow>
              <TableCell className={'label'}>Empresa Contratada</TableCell>
              <TableCell className={'value'}>
                <Fornecedor item={content.fornecedor} />
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell className={'label'}>Data de início</TableCell>
            <TableCell className={'value'}>
              <LocalDate date={content.start} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={'label'}>Data prevista de término</TableCell>
            <TableCell className={'value'}>
              {content.data_prevista ? (
                <LocalDate date={content.data_prevista} />
              ) : (
                <span>{'-'}</span>
              )}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={'label'}>Data prevista de reinício</TableCell>
            <TableCell className={'value'}>
              {content.data_reinicio ? (
                <LocalDate date={content.data_reinicio} />
              ) : (
                <span>{'-'}</span>
              )}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={'label'}>Data de término</TableCell>
            <TableCell className={'value'}>
              {content.end ? (
                <LocalDate date={content.end} />
              ) : (
                <span>{'-'}</span>
              )}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={'label'}>Percentual executado</TableCell>
            <TableCell className={'value'}>
              {content.percentual ? (
                <span>{content.percentual}%</span>
              ) : (
                <span>{'0%'}</span>
              )}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={'label'}>Planejado x Executado</TableCell>
            <TableCell className={'value'}>
              {content.planejado_executado ? (
                <span>{content.planejado_executado.title}</span>
              ) : (
                <span>{'0%'}</span>
              )}
            </TableCell>
          </TableRow>
          {file_href && (
            <TableRow>
              <TableCell className={'label'}>Planilha original</TableCell>
              <TableCell className={'value'}>
                <span className={'link'}>
                  <DownloadLink
                    format={'pdf'}
                    title={'Download'}
                    href={file_href}
                  />
                </span>
              </TableCell>
            </TableRow>
          )}
          {file_acompanhamento_href && (
            <TableRow>
              <TableCell className={'label'}>Planilha acompanhamento</TableCell>
              <TableCell className={'value'}>
                <span className={'link'}>
                  <DownloadLink
                    format={'pdf'}
                    title={'Download'}
                    href={file_acompanhamento_href}
                  />
                </span>
              </TableCell>
            </TableRow>
          )}
          {content.motivo_paralizacao && (
            <TableRow>
              <TableCell className={'label'}>Motivo da paralização</TableCell>
              <TableCell className={'value'}>
                <span>{content.motivo_paralizacao}</span>
              </TableCell>
            </TableRow>
          )}
          {content.responsavel_inexecucao && (
            <TableRow>
              <TableCell className={'label'}>
                Responsável pela inexecução
              </TableCell>
              <TableCell className={'value'}>
                <span>{content.responsavel_inexecucao}</span>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Container>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
ObraView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
  }).isRequired,
};

export default ObraView;
